import { render, staticRenderFns } from "./TableType4.vue?vue&type=template&id=774a61d2&scoped=true&"
import script from "./TableType4.vue?vue&type=script&lang=js&"
export * from "./TableType4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774a61d2",
  null
  
)

export default component.exports